import Back from "@@/core/components/shared/Back/Back";
import mixins from "@@/core/mixins/mixins";
import { BTable } from "bootstrap-vue";

export default {
  mixins: [mixins],

  components: {
    Back,
    BTable,
  },

  data() {
    return {
      loading: false,
      disabled: false,

      action: {},

      customerActions: {
        data: [],
        current_page: 1,
        last_page: 1,
        total: 0,
      },

      fields: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "customer",
          label: "مشتری",
        },
        {
          key: "mobile",
          label: "شماره موبایل",
        },
        {
          key: "gift_balance",
          label: "اعتبار هدیه",
        },
        {
          key: "used_gift_balance",
          label: "مصرف‌شده",
        },
        {
          key: "remaining_balance",
          label: "باقی‌مانده",
        },
        {
          key: "status",
          label: "وضعیت",
        },
      ],
    };
  },

  computed: {
    customers() {
      return this.customerActions.data || [];
    },

    actionType() {
      const types = {
        wallet_charge: "شارژ کیف پول",
        wallet_deposit: "افزایش کیف پول",
        wallet_withdraw: "کاهش کیف پول",
        score_increment: "افزایش امتیاز",
        score_decrement: "کاهش امتیاز",
      };

      return types[this.action.type] || this.action.type || "—";
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.loadData();
    }
  },

  methods: {
    async loadData(page = 1) {
      this.loading = true;
      this.disabled = true;

      try {
        const response = await this.$axios.get(
          `admin/actions/${this.$route.params.id}`,
          {
            params: {
              page,
            },
          }
        );

        const data = response.data.data || {};

        this.action = data.action || {};
        this.customerActions = data.customerActions || {
          data: [],
          current_page: 1,
          last_page: 1,
          total: 0,
        };
      } catch (error) {
        console.error("خطا در دریافت عملیات:", error);

        this.action = {};
        this.customerActions = {
          data: [],
          current_page: 1,
          last_page: 1,
          total: 0,
        };
      } finally {
        this.loading = false;
        this.disabled = false;
      }
    },

    changePage(page) {
      this.loadData(page);
    },

    customerName(customer) {
      if (!customer) {
        return "مشتری نامشخص";
      }

      return (
        `${customer.first_name || ""} ${customer.last_name || ""}`.trim() ||
        "بدون نام"
      );
    },

    remainingBalance(item) {
      const giftBalance = Number(item.gift_balance) || 0;
      const usedBalance = Number(item.used_gift_balance) || 0;

      return giftBalance - usedBalance;
    },
  },
};